<template>
  <div>
    <b-row>
      <b-col
        v-if="loading"
        cols="12"
      >
        <loading-card />
      </b-col>
      <template v-else>
        <b-col cols="12">
          <primary-heading title-text="Yeni Bağlantılar" />
          <b-row>
            <b-col
              cols="12"
              md="8"
            >
              <b-row>
                <b-col
                  cols="12"
                  md="12"
                >
                  <default-card
                    title="Genel Toplam"
                    :value="newConnections.grandTotal.connections"
                    icon="LinkIcon"
                    color="success"
                  />
                </b-col>
                <b-col
                  v-for="item in newConnections.data"
                  :key="item.id"
                  cols="12"
                  md="6"
                >
                  <default-card
                    :title="item.title"
                    :value="item.connections"
                    icon="LinkIcon"
                    color="success"
                    :data-object="{id_com_brand:item.id}"
                    :data-modal="connectionDetailModal"
                  />
                </b-col>
              </b-row>
            </b-col>
            <b-col
              cols="12"
              md="4"
            >
              <pie-charts
                v-if="newConnections.grandTotal.chartData.series.length > 0"
                chart-title="Yeni Bağlantılar"
                chart-type="donut"
                :series-data="newConnections.grandTotal.chartData.series"
                :categories-data="newConnections.grandTotal.chartData.labels"
              />
            </b-col>
          </b-row>
        </b-col>
        <b-col cols="12">
          <primary-heading title-text="Geçen Aydan Devredilen Bağlantılar" />
          <b-row>
            <b-col
              cols="12"
              md="8"
            >
              <b-row>
                <b-col
                  cols="12"
                  md="12"
                >
                  <default-card
                    title="Genel Toplam"
                    :value="lastMonth.grandTotal.connections"
                    icon="LinkIcon"
                    color="primary"
                  />
                </b-col>
                <b-col
                  v-for="item in lastMonth.data"
                  :key="'last_' + item.id"
                  cols="12"
                  md="6"
                >
                  <default-card
                    :title="item.title"
                    :value="item.connections"
                    icon="LinkIcon"
                    color="primary"
                    :data-object="{id_com_brand:item.id}"
                    :data-modal="connectionDetailModal"
                  />
                </b-col>
              </b-row>
            </b-col>
            <b-col
              cols="12"
              md="4"
            >
              <pie-charts
                v-if="lastMonth.grandTotal.chartData.series.length > 0"
                chart-title="Devreden Bağlantılar"
                chart-type="donut"
                :series-data="lastMonth.grandTotal.chartData.series"
                :categories-data="lastMonth.grandTotal.chartData.labels"
              />
            </b-col>
          </b-row>
        </b-col>
      </template>
    </b-row>
    <b-modal
      v-model="showDetailModal"
      title="Bağlantı Detayları"
      no-close-on-backdrop
      no-close-on-esc
      size="xl"
      centered
    >

      <template v-if="loadingDetail">
        <loading-card :is-flat="true" />
      </template>
      <template v-else>
        <template v-if="detailData.data">
          <b-table
            v-if="detailData.data.length > 0"
            :items="detailData.data"
            :fields="fields"
            small
            responsive
            striped
          />
          <b-alert
            v-else
            show
            variant="info"
            class="m-2"
          >
            <div class="alert-body text-center">
              Markaya ait bağlantı araç verisi bulunmuyor.
            </div>
          </b-alert>
        </template>
        <b-alert
          v-else
          show
          variant="danger"
          class="m-2"
        >
          <div class="alert-body text-center">
            Veriler yüklenirken bir hata oluştu.
          </div>
        </b-alert>
      </template>

      <template #modal-footer>
        <b-button
          variant="secondary"
          @click="showDetailModal=false"
        >
          Tamam
        </b-button>
      </template>
    </b-modal>
  </div>
</template>
<script>
import {
  BRow, BCol, BModal, BButton, BTable, BAlert,
} from 'bootstrap-vue'
import DefaultCard from '@/layouts/components/ReportCards/DefaultCard.vue'
import LoadingCard from '@/layouts/components/Loading.vue'
import PrimaryHeading from '@/layouts/components/PrimaryHeading.vue'
import PieCharts from '@/layouts/components/ReportCharts/PieCharts.vue'

export default {
  name: 'Sales',
  components: {
    BAlert,
    DefaultCard,
    LoadingCard,
    PrimaryHeading,
    PieCharts,
    BRow,
    BCol,
    BModal,
    BButton,
    BTable,
  },
  data() {
    return {
      showDetailModal: false,
      loadingDetail: false,
      fields: [
        {
          key: 'customer',
          label: 'Müşteri',
          thClass: 'font-small-3 align-middle',
          tdClass: 'font-small-3 text-ellipsis',
        },
        {
          key: 'order_number',
          label: 'Föy No',
          thClass: 'font-small-3 align-middle',
          tdClass: 'font-small-3 text-ellipsis',
        },
        {
          key: 'brand',
          label: 'Marka',
          thClass: 'font-small-3 align-middle',
          tdClass: 'font-small-3 text-ellipsis',
        },
        {
          key: 'model',
          label: 'Model',
          thClass: 'font-small-3 align-middle',
          tdClass: 'font-small-3 text-ellipsis',
        },
        {
          key: 'chasis',
          label: 'Şase',
          thClass: 'font-small-3 align-middle',
          tdClass: 'font-small-3 text-ellipsis',
        },
        {
          key: 'created',
          label: 'Bağlantı Tarihi',
          thClass: 'font-small-3 align-middle',
          tdClass: 'font-small-3 text-ellipsis',
        },
        {
          key: 'dateDiff',
          label: 'Geçen Gün',
          thClass: 'font-small-3 align-middle',
          tdClass: 'font-small-3 text-ellipsis',
        },
        {
          key: 'username',
          label: 'Danışman',
          thClass: 'font-small-3 align-middle',
          tdClass: 'font-small-3 text-ellipsis',
        },
      ],
    }
  },
  computed: {
    loading() {
      return this.$store.getters['saleReports/loading']
    },
    newConnections() {
      return this.$store.getters['saleReports/newConnections']
    },
    lastMonth() {
      return this.$store.getters['saleReports/lastMonth']
    },
    detailData() {
      return this.$store.getters['saleReports/connectionDetail']
    },
  },
  created() {
    this.getData()
  },
  methods: {
    getData() {
      this.$store.commit('saleReports/SET_LOADING', true)
      return this.$store.dispatch('saleReports/getNewConnections')
        .then(response => {
          if (response) {
            this.$store.dispatch('saleReports/getLastMonth')
              .then(res => {
                if (res) {
                  this.$store.commit('saleReports/SET_LOADING', false)
                }
              })
          }
        })
    },
    connectionDetailModal(data) {
      this.loadingDetail = true
      this.showDetailModal = true
      this.$store.dispatch('saleReports/getConnectionDetail', {
        id_com_brand: data.id_com_brand,
      }).then(response => {
        if (response) {
          this.loadingDetail = false
        }
      })
    },
  },
}
</script>
